import 'intersection-observer'
import * as React from "react"
import { InView } from 'react-intersection-observer'
import { fromJSX, IOWidget, Updater } from "widgets-for-react"
import { PublicSiteState } from "../../../../../../../root/state"
import { cookiebar, is_cookie_accepted } from "../../../../cms/blocks/cookiebar/cookiebar.widget.mod"
import { CMSState } from "../../../../cms/blocks/types.gen"
import { getClassName } from "../../../../cms/blocks/utils.gen"
import { get_iframe_props } from '../../../../public_site/utils/helpers'
import { blockInviewHandler } from "../../../utils/inview_utils"

export type IframeCodeBlockProps = {
  index: number
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
  iframe?: string
}

export type IframeCodeBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  iframe_classname: string
  cookies_classname: string
  cookies_inner_classname: string
  cookies_text_classname: string
  cookies_clickable_classname: string
}>


export function IframeCodeBlock(
  props: IframeCodeBlockProps,
  options?: { style?: IframeCodeBlockStyle; key?: string }
): (
    s: CMSState,
    set_public_site: (output: Updater<PublicSiteState>) => void
  ) => IOWidget<PublicSiteState, Updater<CMSState>> {
  return (s: CMSState, set_public_site: (output: Updater<PublicSiteState>) => void) => (public_state: PublicSiteState) =>
    fromJSX(() => (
        <InView
          as="section"
          onChange={(inView) => blockInviewHandler('iframe', inView, `io-${options && options.key ? options.key : props.index}`, getClassName(options, "inview_classname", "inview"))}
          triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
          threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
          id={`io-${options && options.key ? options.key : props.index}`}
          className='block block--iframe block--iframe-compact ls-block-spacing'
          key={options && options.key ? options.key : `block-${props.index}`}
        >
          <div className='block__inner ls-container'>
            <div className='block__content'>
              {!is_cookie_accepted("video-cookies") ?
                cookiebar(public_state.cookiestate, "video-cookies").run(a_cs => {
                  set_public_site(s1 => {
                    return { ...s1, cookiestate: a_cs(s1.cookiestate) }
                  })
                })
                : <RenderEmbed html={props.iframe} />

              }
            </div>
          </div>
        </InView>
      )
    )
}



interface RenderEmbedProps {
  html: string
}

const RenderEmbed = (props: RenderEmbedProps) => {
  if (props.html.match(/^\s*<iframe (.*?)(\/?>|><\/iframe>)\s*$/) == null) {
    console.error('Invalid HTML in iframe block ', props.html)
    return <div className='block__iframe'>
      Error: Invalid HTML tags, your HTML code might contain forbidden tags
      <h4>Alowed tags</h4>
      <ul>
        <li><code>{'<iframe>'}</code></li>
      </ul>
      <div>
        <h5>iframe input: </h5>
        <code>
          {props.html}
        </code>
      </div>
    </div>
  }

  let attrs = get_iframe_props(props.html)
  // console.log(attrs)

  let width = attrs['width'] ? attrs['width'] : "100"
  let height = attrs['height'] ? attrs['height'] : '100'
  let aspect_ratio = 1
  if (!isNaN(Number(attrs['width']))) {
    aspect_ratio = Number(width) / Number(height)
  } else {
    height = attrs["height"]

  }

  const css = `
    .block__iframe--${width}-${height} {
        aspect-ratio: ${aspect_ratio};
        height: auto;
    }
`
  return <>
    <style>{css}</style>
    <iframe className={`block__iframe block__iframe--${width}-${height}`} {...attrs} />
  </>
}


